export const formatPriceToBackend = ({
  price,
  currency,
  type,
  downPayment,
}: {
  price?: string | number;
  currency: string;
  type: string;
  downPayment?: string | number;
}) => {
  const amount = Number(price);
  const onlinePrice = downPayment ? Number(downPayment) : Number(price);

  return {
    currency,
    ...(price && { amount }),
    ...(type === 'bottleService' && { onlinePrice }),
    ...(type === 'bottleService' && { offlinePrice: amount - onlinePrice }),
  };
};
